import { masmovilTheme, llamayaTheme } from './theme'

export * from './utils'

export enum Themes {
  masmovil = 'masmovil',
  llamaya = 'llamaya',
}

export const themes = {
  masmovil: masmovilTheme,
  llamaya: llamayaTheme,
}

export * from './card'
export * from './link'
export * from './colors'
export * from './fonts'
